import React from "react"
import {WireCounterparty as PaymentWireCounterparty, WireInvolvedInstitutions} from "../../resources/payment"
import {WireCounterparty as IncomingWireCounterparty} from "../../resources/incomingWire"
import {KeyValueCardView} from "../RenderKeyValueCard/KeyValueCardView"
import {addressText} from "../../utilities/helpers"

type CounterpartyDetailsCardProps = {
	data: PaymentWireCounterparty | IncomingWireCounterparty
	involvedInstitutions?: WireInvolvedInstitutions
	singleColumn?: boolean
	disabled?: boolean
	className?: string
}

export function CounterpartyDetailsCard({
	data,
	involvedInstitutions,
	singleColumn,
	disabled,
	className,
}: CounterpartyDetailsCardProps) {
	const {name, routingNumber, accountNumber, address} = data
	const {receiverDepositInstitution} = involvedInstitutions || {}
	const {name: bankName, address: bankAddress} = receiverDepositInstitution || {}
	const addressElement = address && <span className={"address-placeholder"}>{addressText(address)}</span>

	const counterpartyDetails = {
		...(name ? {name} : {}),
		...(address ? {address: addressElement} : {}),
		...(routingNumber ? {routingNumber} : {}),
		...(accountNumber ? {accountNumber} : {}),
		...(bankName ? {bankName} : {}),
		...(bankAddress ? {bankAddress} : {}),
	}

	return (
		<KeyValueCardView
			details={counterpartyDetails}
			title="Counterparty Details"
			singleColumn={singleColumn}
			disabled={disabled}
			className={className}
		/>
	)
}
